import script from "./ProductPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductPage.vue?vue&type=script&setup=true&lang=ts"

import "./ProductPage.vue?vue&type=style&index=0&id=2aace567&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2aace567"]])

export default __exports__